// Aplica `fn` a cada item com no máximo `limite` chamadas ao mesmo tempo e
// devolve os resultados na ordem da entrada. Um item que falha vira
// `{ erro }` e não interrompe os outros.
export async function mapComConcorrencia(itens, limite, fn) {
  const resultados = new Array(itens.length);
  let proximo = 0;
  const trabalhador = async () => {
    while (proximo < itens.length) {
      const indice = proximo++;
      try {
        resultados[indice] = { valor: await fn(itens[indice], indice) };
      } catch (erro) {
        resultados[indice] = { erro };
      }
    }
  };
  const total = Math.max(1, Math.min(limite, itens.length));
  await Promise.all(Array.from({ length: total }, trabalhador));
  return resultados;
}
